import { render, staticRenderFns } from "./RolePage.vue?vue&type=template&id=4760e1d8"
import script from "./RolePage.vue?vue&type=script&lang=js"
export * from "./RolePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4760e1d8')) {
      api.createRecord('4760e1d8', component.options)
    } else {
      api.reload('4760e1d8', component.options)
    }
    module.hot.accept("./RolePage.vue?vue&type=template&id=4760e1d8", function () {
      api.rerender('4760e1d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/role/RolePage.vue"
export default component.exports